export enum GenericErrorType {
    ALREADY_LOGIN_ERR = 'ALREADY_LOGIN_ERR',
    INVALID_SESSION_ERR = 'INVALID_SESSION_ERR',
    UNEXPECTED_ERR = 'UNEXPECTED_ERR',
    CONSENT_DENIED_ERR = 'CONSENT_DENIED_ERR',
    GENERAL_ERR = 'GENERAL_ERR',
    DIFFERENT_USER_ERR = 'DIFFERENT_USER_ERR',
}
